module.exports = __webpack_public_path__ + "static/img/15.0dc0615d.gif";